(() => {
  if (window.__teeMapsMaskInit) return;
  window.__teeMapsMaskInit = true;

  function stripLatLon(input) {
    const re = /\s*(?:-+|–|—)?\s*\(?\s*[+-]?\d+(?:\.\d+)?\s*,\s*[+-]?\d+(?:\.\d+)?\s*\)?\.?$/;
    return (input || '').replace(re, '').trim();
  }

  function injectStyle() {
    if (document.getElementById('tee-maps-mask-style')) return;
    const style = document.createElement('style');
    style.id = 'tee-maps-mask-style';
    style.textContent = `
    .tee-field-maps-name.tee-masked{
      position:relative;
      display:inline-block;                 
      color:transparent !important;         
      -webkit-text-fill-color:transparent; 
    }
    .tee-field-maps-name.tee-masked::after{
      content:attr(data-display-text);
      position:absolute;
      inset:0;                             
      white-space:inherit;
      color:#111 !important;               
      -webkit-text-fill-color:#111;
      pointer-events:none;
    }
  `;
    document.head.appendChild(style);
  }

  function enhance(el) {
    if (!el || el.nodeType !== 1) return;
    const raw = el.innerText || el.textContent || '';
    const cleaned = stripLatLon(raw);
    if (el.dataset.displayText !== cleaned) el.dataset.displayText = cleaned || '';
    if (!el.classList.contains('tee-masked')) el.classList.add('tee-masked');
  }

  function enhanceAll(root = document) {
    root.querySelectorAll('.tee-field-maps-name').forEach(enhance);
  }

  function observeGlobal() {
    if (window.__teeMapsMaskMO) return;
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          m.addedNodes.forEach((n) => {
            if (n.nodeType !== 1) return;
            if (n.matches?.('.tee-field-maps-name')) enhance(n);
            n.querySelectorAll?.('.tee-field-maps-name').forEach(enhance);
          });
        }
        if (m.type === 'characterData') {
          const el = m.target.parentElement?.closest?.('.tee-field-maps-name');
          if (el) enhance(el);
        }
      }
    });
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true
    });
    window.__teeMapsMaskMO = mo;
  }

  function observeTextExisting() {
    document.querySelectorAll('.tee-field-maps-name').forEach((el) => {
      if (el.__teeTextMO) return;
      const moText = new MutationObserver(() => enhance(el));
      moText.observe(el, {
        characterData: true,
        subtree: true,
        childList: true
      });
      el.__teeTextMO = moText;
    });
  }

  function run() {
    injectStyle();
    enhanceAll();
    observeGlobal();
    observeTextExisting();
  }

  document.addEventListener('teeinblue-event-component-injected', run);
})();